<button mat-icon-button (click)="previousClicked()" class="arrow" [class.disabled]="prevButtonDisabled">
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
    <path
      d="M5 1.50098L1 5.50098L5 9.50098"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</button>
<span class="header-label">{{ periodLabel }}</span>
<button mat-icon-button (click)="nextClicked()" class="arrow" [class.disabled]="nextButtonDisabled">
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
    <path
      d="M1 9.50098L5 5.50098L1 1.50098"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</button>
